import { mapVenueDetailsType, useFindVenueSuspense } from '@api';
import {
  TouringCard,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.general';
import { ContactPersonsTable } from './components';

export const VenueOperatorContactPersons: React.FC = () => {
  const { t } = useTranslation('venueDetailsGeneral');
  const { id } = Route.useParams();
  const { data: venueOperator } = useFindVenueSuspense(id, {
    query: { select: (data) => mapVenueDetailsType(data.data).venueOperator },
  });

  if (!venueOperator || venueOperator.contactPersons.length === 0) return null;

  return (
    <TouringCard data-testid="venue-operator-contact-persons-card">
      <TouringCardHeader>
        <TouringCardTitle>
          {t('VENUE_OPERATOR_CONTACT_PERSONS.TITLE')}
        </TouringCardTitle>
      </TouringCardHeader>
      <TouringCardSection>
        <ContactPersonsTable contactPersons={venueOperator.contactPersons} />
      </TouringCardSection>
    </TouringCard>
  );
};
